import { phoneMockups } from '../data/landingPageData';
import './PhoneMockup.css';

function PhoneMockup({ variant = 'feed', tilt = 'none' }) {
  const mockup = phoneMockups[variant] || phoneMockups.feed;

  return (
    <div className={`phone phone-${variant} phone-${tilt}`}>
      <img className="phone-image" src={mockup.src} alt={mockup.alt} />
    </div>
  );
}

export default PhoneMockup;
